module.exports = __webpack_public_path__ + "media/social/social-1-c05ce1b0.jpg";